<mat-card class="mb-4 rounded-3xl border border-slate-200 p-4 shadow-lg shadow-slate-200/60">
  <div class="mb-3 flex items-center justify-between gap-3">
    <h3 class="text-lg font-semibold text-slate-900">Referrer</h3>
    @if (canEdit() && !editing()) {
      <div class="flex gap-2">
        @if (!isEmpty()) {
          <button mat-stroked-button type="button" [disabled]="store.savingReferrer()" (click)="remove()">Remove</button>
        }
        <button mat-stroked-button type="button" (click)="edit()">{{ isEmpty() ? 'Record referrer' : 'Edit' }}</button>
      </div>
    }
  </div>

  @if (editing()) {
    <form [formGroup]="form" (submit)="$event.preventDefault(); save()" class="grid gap-4">
      <!-- Who asked for the help (a manager, HR, a colleague); the member is not the referrer unless they self referred -->
      <div class="grid gap-x-4 md:grid-cols-3">
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput maxlength="100" formControlName="name" />
          @if (form.controls.name.hasError('required')) {
            <mat-error>Name is required.</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Surname</mat-label>
          <input matInput maxlength="100" formControlName="surname" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Position</mat-label>
          <input matInput maxlength="100" formControlName="position" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Email address</mat-label>
          <input matInput type="email" maxlength="320" formControlName="emailAddress" />
          @if (form.controls.emailAddress.hasError('email')) {
            <mat-error>Enter a valid email address.</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Office number</mat-label>
          <input matInput maxlength="50" formControlName="officeNumber" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Mobile number</mat-label>
          <input matInput maxlength="50" formControlName="mobileNumber" />
        </mat-form-field>
      </div>

      <div class="flex justify-end gap-2">
        <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
        <button mat-flat-button type="submit" [disabled]="store.savingReferrer()">
          @if (store.savingReferrer()) {
            <mat-spinner diameter="20" class="mr-2" />
          }
          Save referrer
        </button>
      </div>
    </form>
  } @else if (isEmpty()) {
    <p class="text-sm text-slate-500">No referrer has been recorded.</p>
  } @else {
    @if (store.referrer(); as referrer) {
      <dl class="grid gap-x-6 gap-y-2 text-sm md:grid-cols-2">
        <div class="flex gap-2">
          <dt class="w-32 shrink-0 text-slate-500">Name</dt>
          <dd class="font-medium text-slate-900">{{ referrer.name }} {{ referrer.surname }}</dd>
        </div>
        <div class="flex gap-2">
          <dt class="w-32 shrink-0 text-slate-500">Position</dt>
          <dd class="font-medium text-slate-900">{{ referrer.position || '-' }}</dd>
        </div>
        <div class="flex gap-2">
          <dt class="w-32 shrink-0 text-slate-500">Email</dt>
          <dd class="font-medium text-slate-900">{{ referrer.emailAddress || '-' }}</dd>
        </div>
        <div class="flex gap-2">
          <dt class="w-32 shrink-0 text-slate-500">Office number</dt>
          <dd class="font-medium text-slate-900">{{ referrer.officeNumber || '-' }}</dd>
        </div>
        <div class="flex gap-2">
          <dt class="w-32 shrink-0 text-slate-500">Mobile number</dt>
          <dd class="font-medium text-slate-900">{{ referrer.mobileNumber || '-' }}</dd>
        </div>
        @if (referrer.referrerEmployeeName) {
          <div class="flex gap-2">
            <dt class="w-32 shrink-0 text-slate-500">Employee record</dt>
            <dd class="font-medium text-slate-900">{{ referrer.referrerEmployeeName }}</dd>
          </div>
        }
      </dl>
    }
  }
</mat-card>
